import { render, staticRenderFns } from "./CatalogSectionDialog.vue?vue&type=template&id=1b53e44a&"
import script from "./CatalogSectionDialog.vue?vue&type=script&lang=js&"
export * from "./CatalogSectionDialog.vue?vue&type=script&lang=js&"
import style0 from "./CatalogSectionDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports